<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="content plr20 bgfff" style="box-sizing: border-box;"
			:class="openType != 'mob' ? 'container_w_h vh100' : ''"
			:style="openType != 'mob' ? 'overflow-y:auto' : 'min-height:100vh'">
			<div class="pt20">
				<div class="page_title mb10">项目人员</div>
			</div>
			<div class="bor_b pt20 pb20">
				<div class="bold mb20">会员</div>
				<div class="flex_items flex flex_warp">
					<div class="list-content mr20" v-for="(item, index) in userList" :key="index">
						{{item.name}}
					</div>
				</div>
				<div class="empty" v-if="userList.length == 0">暂无数据</div>
			</div>
			<div class="mt20 bor_b pb20">
				<div class="bold mb20">工作人员</div>
				<div class="flex_items flex flex_warp">
					<div class="list-content mr20" v-for="(item, index) in offList" :key="index">
						{{item.name}}
					</div>
				</div>
				<div class="empty" v-if="offList.length == 0">暂无数据</div>
			</div>

			<div class="btn-box">
				<a href="/h5/temaplte/project-user.xlsx" download="项目人员关联导入模板.xlsx">
					<div class="upload main_bg cf">
						模板 <br>下载
					</div>
				</a>
				<div class="upload main_bg cf pos">
					<input type="file" class="inp" id="file" @change="upload($event)">
					导入
				</div>
			</div>
			
		</div>
		<div class="bottom_btn bottom_btn" @click="$router.push({path:'/setmember',query:{id:id}})">
			<div class="btn_contenbt mr10">设置项目人员</div>
		</div>
	</div>
</template>

<script>
	import {
		openType
	} from '@/utils/tool.js'
	export default {
		data() {
			return {
				list: [],
				id: '',
				userList:[],
				offList:[],
				openType: openType()
			}
		},
		methods: {
			getlist() {
				this.api.projectUser({}, this.id).then(res => {
					this.list = res.data;
					this.userList = [];
					this.offList = [];
					this.list.map(r => {
						if(r.role == 'member'){
							this.userList.push(r)
						}else{
							this.offList.push(r)
						}
					})
				})
			},
			upload(files){
				// console.log(files.target.files);
				if (files) {
					let file = files.target.files[0];
					const fromData = new FormData()
					fromData.append('file', file)
					// fromData.append('api_token', this.api_token)
					this.api.projectUserImport(fromData, this.id).then(r => {
						if (r.code == 0) {
							// this.$emit('uploadFile', r.data)
							// console.log(r.message);
							if(r.message){
								this.Toast(r.message);
							}
							this.getlist();
						}else{
							this.Toast(r.message);
						}
					})
					var obj = document.getElementById('file'); 
					obj.value = '';
				}
				
			},
		},
		created() {
			this.id = this.$route.query.id;
			this.getlist()
		}
	}
</script>

<style scoped="scoped">
	.bg_blue{
		color: #3399FF;
		background-color: #C2E1FF;
	}
	.gr_bg{
		background-color: #D1F0E1;
		color: #00D8CC;
	}
	.btn-box{
		position: fixed;
		bottom: 100px;
		right: 10px;
	}
	.container_w_h .btn-box{
		right: calc( 50vw - 180px);
		bottom: 150px;
	}
	.upload{
		width: 50px;
		height: 50px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		font-size: 15px;
		margin-top: 10px;
	}


	.inp{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}
</style>
